import { SET_COLLAPSED } from "./actionTypes";

const SideNavActions = {
  setCollapsed(isCollapsed) {
    return { type: SET_COLLAPSED, isCollapsed };
  },
}

export { SideNavActions };
